import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import { ILocalization } from "../../../models/localization";
import { ProfileViewState, ExperienceType } from "../../../models/enums";
import SeekerStore from "../../../stores/seekerStore";
import SkillSummary from "../skillSummary";
import ExperienceSummary from "../experienceSummary";
import { Grid, Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import AppBar from "material-ui/AppBar";
import Tabs, { Tab } from "material-ui/Tabs";
import FloatingAddBtn from "../../widgets/addBtn";
import * as s from "./summary.css";

@observer
export default class SummaryContainer extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  @action handleTabChange = (event: Object, value: number): void => {
    this.props.store.profileStore.setProfileViewMode(value);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;

    return (
      <Paper elevation={1} className={s.box}>
        <AppBar position="static" color="secondary">
          <Tabs
            onChange={this.handleTabChange}
            value={this.props.store.profileStore.profileViewMode}>
            <Tab value={0} label={local.mySkills} color="primary" />
            <Tab value={1} label={local.myExperiences} />
          </Tabs>
        </AppBar>
        <Row className={s.container}>
          <Col xs={12}>
            <Row>
              <Col xs={8}>
              {this.props.store.profileStore.profileViewMode === ProfileViewState.SkillsView && <h5 className={s.blueHeader}>{this.props.store.localization.fields.mySkills}</h5>}
              {this.props.store.profileStore.profileViewMode === ProfileViewState.ExperienceView && <h5 className={s.blueHeader}>{this.props.store.localization.fields.myExperiences}</h5>}
              </Col>
              <Col xs={4}><FloatingAddBtn store={this.props.store} n={this.props.store.profileStore.profileViewMode === ProfileViewState.SkillsView ? 2 : 1} /></Col>
            </Row>
            {this.props.store.profileStore.profileViewMode === ProfileViewState.SkillsView && <SkillSummary store={this.props.store} />}
            {this.props.store.profileStore.profileViewMode === ProfileViewState.ExperienceView && <ExperienceSummary store={this.props.store} />}
         </Col>       
        </Row>
      </Paper>
     );
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/summaryContainer/index.tsx